<script>
  export let image;
</script>

<style>
.root {
  flex: 1;
  display: flex;
  flex-direction: row;
  
  padding: 20px;
  height: 100vh;
  box-sizing: border-box;
}

.image {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.image img {
  max-width: 100%;
  max-height: 80vh;  
}


.text {
  flex: 1;
  padding: 0 30px;
  color: white;
  font-size: 25px;
  line-height: 1.3;  
}

.author {
  font-style: italic;
}

@media (orientation: portrait) {
  .root {
    display: block;
  }
  .image {
    flex: initial;
  };

  .text {
    padding: 30px 0;
  }
}

@media (orientation: landscape) {  
  .text {
    display: flex;
    flex-direction: column;
    
    /** We want this when large **/
    justify-content: center;
  }

  .text2 {
    display: flex;
    flex-direction: column;

    /** In potrait we scroll the whole page **/    
    overflow: auto;
  }
}


h3 { 
  font-size: 35px;
  margin: 15px 0 0;
}
.size {
  margin: 1em 0;
  color: gray;
}
.author {
  margin: 1em 0;
}
</style>

<div class="root">
  <div class="image">
    <img src={image} alt="A Carpet Piece." />
  </div>  
  <div class="text">
    <div class="text2">
      <h3>The Caterpillar Who Didn’t Become a Butterfly</h3>
      <div class="size">
        <div>35x41x5 cm</div>
      </div>      
      <div>
        A set of Persian Carpets. The carpet is kept on the loom, and parts are purposefully left unwoven, exposing the warp threads. By deconstructing both the patterns and the structure of a carpet, I am drawing attention to the mechanics.     
      </div>
      <div class="author">
        Armaghan Fatemi, 2019
      </div>
    </div>
  </div>
</div>